import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/QuestionFileNew.vue';
export default {
  name: 'true-false',
  components: {
    QuestionFile: QuestionFile
  },
  props: {
    isBook: {
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsAnswers: {
      type: Boolean,
      default: 0
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {},
  data: function data() {
    return {
      urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
      // 题干附件
      fileList: [],
      fileIds: [],
      // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      showThisAnswer: true,
      anaShow: true,
      content: '请输入内容',
      formOption: {
        choice: null
      },
      stuAnswer: []
    };
  },
  methods: {
    // 做作业是选择答案
    doCheckValue: function doCheckValue() {
      this.$emit('getAnswer', {
        Id: this.data.Id,
        Answers: this.stuAnswer
      });
    },
    upDown: function upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    }
  },
  created: function created() {
    if (this.data.Answers) {
      this.stuAnswer = this.data.Answers;
    } // 题目附件


    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  }
};